module.exports = __webpack_public_path__ + "static/media/convince.bdd11ca0.gif";